import * as actionTypes from '../actionTypes';

// initial state
export const initialState = {};

export default function jobRequestDocumentsReducer(state = initialState, {type, ...action}) {
  switch (type) {

    case actionTypes.CREATE_JOB_REQUEST_DOCUMENTS:
      return Object.assign({}, action);

    case actionTypes.UPDATE_JOB_REQUEST_DOCUMENTS:
      return {...state, documents: action.documents};

    case actionTypes.RESET_JOB_REQUEST_DOCUMENTS:
      return {};

    case actionTypes.LOG_OUT :
      return Object.assign(initialState);

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./shared/redux/reducers/jobRequestDocuments.js